import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { Phone, Navigation, ShoppingBag } from 'lucide-react';
import { BUSINESS } from '../config';

export default function MobileBar() {
  const location = useLocation();
  if (location.pathname.startsWith('/my') || location.pathname.startsWith('/compte')) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 glass border-t border-slate-200 p-2 z-50 flex justify-around items-center md:hidden safe-area-bottom" data-testid="mobile-bar">
      <a
        href={`tel:${BUSINESS.telephoneRaw}`}
        className="flex flex-col items-center gap-0.5 py-2 px-3 rounded-sm text-secondary hover:bg-secondary/10 transition-colors"
        data-testid="mobile-bar-call"
      >
        <Phone className="w-5 h-5" />
        <span className="text-[10px] font-medium">Appeler</span>
      </a>
      <a
        href={BUSINESS.urlGoogleMaps}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-col items-center gap-0.5 py-2 px-3 rounded-sm text-slate-700 hover:bg-slate-100 transition-colors"
        data-testid="mobile-bar-directions"
      >
        <Navigation className="w-5 h-5" />
        <span className="text-[10px] font-medium">Itinéraire</span>
      </a>
      <Link
        to="/catalogue"
        className="flex flex-col items-center gap-0.5 py-2 px-3 rounded-sm text-slate-700 hover:bg-slate-100 transition-colors"
        data-testid="mobile-bar-catalogue"
      >
        <ShoppingBag className="w-5 h-5" />
        <span className="text-[10px] font-medium">Catalogue</span>
      </Link>
    </div>
  );
}
